import { randomBetween, scaleStreamDelay } from './computeStreamTypingDuration.js'

/** Target animation speed vs original 1/6 baseline (10 = 10× faster). */
export const CHAT_STREAM_ANIMATION_SPEED = 10

/** Values < 1 run faster; 1/30 = 5× vs original 1/6 baseline. */
export const CHAT_STREAM_SPEED_FACTOR = 1 / (6 * CHAT_STREAM_ANIMATION_SPEED)

/** 2× faster than {@link CHAT_STREAM_SPEED_FACTOR} — block/result typewriters. */
export const CHAT_STREAM_CONTENT_SPEED_FACTOR = 1 / (12 * CHAT_STREAM_ANIMATION_SPEED)

export const CHAT_STREAM_PREAMBLE_PAUSE_MIN_MS = 1000
export const CHAT_STREAM_PREAMBLE_PAUSE_MAX_MS = 2000

/** @param {number} ms @param {number} [speedFactor] */
export function scaleChatStreamDelay(ms, speedFactor = CHAT_STREAM_SPEED_FACTOR) {
  return scaleStreamDelay(ms, speedFactor)
}

/** @param {number} ms */
export function scaleChatStreamContentDelay(ms) {
  return scaleChatStreamDelay(ms, CHAT_STREAM_CONTENT_SPEED_FACTOR)
}

/** Unscaled pause for thinking / worked beats (always 1–2s regardless of stream speed). */
export function randomPreamblePauseMs() {
  return randomBetween(CHAT_STREAM_PREAMBLE_PAUSE_MIN_MS, CHAT_STREAM_PREAMBLE_PAUSE_MAX_MS)
}

/** @param {number} ms */
export function scaleChatStreamThinkingDelay(ms) {
  return scaleChatStreamDelay(ms)
}
